import React from 'react';
import ReactDOM from 'react-dom';
import { Provider, } from 'react-redux';

import './index.css';
import { App, } from './views/layouts';
import * as serviceWorker from 'serviceWorker';
import configureStore from './store';

const store = configureStore.createStore();
configureStore.runSaga();

ReactDOM.render(
    <Provider store={store}>
        <App/>
    </Provider>,
    document.getElementById('root'),
);

serviceWorker.unregister();
